var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-centerize",class:{ 'visibility-hidden': _vm.numOfComments === 0 }},[_c('span',[_vm._v(_vm._s(_vm.numOfComments)+" "),_c('SIcon',{staticClass:"ml-1",attrs:{"name":"bubble-msg"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }